import { Component,ViewChild  } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController} from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { HomePage } from '../../pages/home/home';
import { ReservaslinPage } from '../../pages/reservaslin/reservaslin';
import { EmpresasPage } from '../../pages/empresas/empresas';
import { ListPage } from '../../pages/list/list';
import { CalendarioPage } from '../../pages/calendario/calendario';

import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as XLSX from '../../xlsx';
import { NgZone  } from '@angular/core';
import { Events } from 'ionic-angular';


import { File } from '@ionic-native/file';
import { AlertController, Alert } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

import { Storage } from '@ionic/storage';
import { AsignarPage } from '../asignar/asignar';

//import * as $ from "jquery";

@IonicPage()

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage {

  public mostrarerror = false;
  datosacceso;
  usuariodatos;
  id;
  subtema;
  code;
  email;
  contrasena;
  usuarioacceso;
  myForm: FormGroup;
  usuario;
  pass;
  pagina;
  seguir;
  trabajador;


  pages: Array<{title: string, component: any}>;
  usuarioaccesoarray: Array<{usuarioacceso: string}>;

  usuariodatosarray: Array<{usuariodatos: string}>;

 formulario = 
 {
  valor: ''
}
 
  constructor(
  private storage: Storage,
  private toastCtrl: ToastController,
  public variablesglobales:VariablesProvider,
  public navParams: NavParams,
  public fb: FormBuilder,
  public alertCtrl: AlertController,
  public modalCtrl: ModalController,
  public navCtrl: NavController,
  public funciones:FuncionesProvider,
  public variables:VariablesProvider,
  public file: File,
  public events: Events,
  ) {

        this.variablesglobales.CONTROLACCESO = 0;
        this.storage.get('DIASELECIONADO').then((DIA) => {
          this.variables.DIA = DIA;         
       })
       if (this.variables.DIA) { 
         // code...
       } else {
         var f = new Date();
         this.variables.DIA =  f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ;
         this.storage.set('DIASELECIONADO', this.variables.DIA );
       }


       this.variables._daysConfig = []; // nueva instancia

       this.variables._daysConfig.push({
          date: new Date(this.variables.DIA),
          cssClass: 'my-day'
        })

        this.storage.get('DIASELECIONADO').then((DIA) => {
          this.variables.DIA = DIA;   
        })



      this.myForm = this.fb.group({
        email: ['', [Validators.required]],
        contrasena: ['', [Validators.pattern(/^[a-z0-9_-]{6,18}$/)]],
      });


      // Cogemos los valores pasados por get
      var valores  =this.getGET();


      if(valores)
      {
        //?s=true&t=tricenter&p=picajes
        //user=tricenter&pass=tri1951
        this.myForm.value.email = valores['user'];
        this.myForm.value.contrasena = valores['pass'];

        this.variablesglobales.emailoriginal = this.myForm.value.email;
        console.log("6º" + this.myForm.value.email);

        
        this.acceso();
        

      }

      

      this.storage.get('usuario').then((val) => {

        
        this.variablesglobales.CLIENTES_RAZSOCIAL=null;
        this.variablesglobales.logged = true;
        this.variablesglobales.CLIENTES_RAZSOCIAL = val;
        if (this.variablesglobales.CLIENTES_RAZSOCIAL == "" || this.variablesglobales.CLIENTES_RAZSOCIAL == null){

        }else{

          this.storage.get('pass').then((pasw) => {
            this.storage.get('appselect').then((valo) => {
            this.variablesglobales.APPSELECT = valo;
            this.variablesglobales.CONTROLACCESO = 50;
            this.funciones.getAcceso2(this.variablesglobales.CLIENTES_RAZSOCIAL, pasw).then(
              data => {


              this.datosacceso = data;
              this.storage.get('valor').then((valor) => {

              for (let usu of this.datosacceso) {


               this.variablesglobales.username = usu["CLIENTES_RAZSOCIAL"];
                //this.variablesglobales.emailactivo = usu["CLIENTES_EMAIL"];
                this.variablesglobales.CODIGOTRABAJADOR = this.variablesglobales.CLIENTES_RAZSOCIAL;


                ////console.log("***************************** NOMBRE TRABAJADOR EN LOGIN --> " + this.variablesglobales.CODIGOTRABAJADOR);
                this.variablesglobales.COLORGLOBAL  =  usu["CLIENTES_COLOR"];
                this.variablesglobales.COLORGLOBAL2  =  usu["CLIENTES_COLOR2"];
                this.variablesglobales.LOGOGLOBAL  =  usu["CLIENTES_LOGO"];
                this.variablesglobales.ESTADOGLOBAL  =  usu["CLIENTES_ESTADO"];
                this.variablesglobales.licenciaactiva="SI";
                this.variablesglobales.licencianumero= usu["CLIENTES_LICENCIA_NUMERO"];
                this.variablesglobales.licencianombre= usu["CLIENTES_LICENCIA_NOMBRE"];
                this.variablesglobales.licenciafecha= usu["CLIENTES_LICENCIA_FECHA"];
                this.variablesglobales.licenciadiasrestantes = usu["CLIENTES_LICENCIA_DIAS_RESTANTES"];
                this.variablesglobales.licenciaestado = usu["CLIENTES_LICENCIA_ESTADO"];
                
                //console.log("***************************** color trabajador --> " + this.variablesglobales.COLORGLOBAL);


                if ( usu["CLIENTES_VALOR"]=="SSSSSSSS"){
                  this.variablesglobales.CONTROLACCESO = 91;
                  //console.log("PONE EN 91")
                }else{
                  this.variablesglobales.CONTROLACCESO = 91;
                  //console.log("PONE EN 50")
                }
                //console.log("Valor de valor: " + this.variablesglobales.CONTROLACCESO );
                this.variablesglobales.uservalor = usu["CLIENTES_VALOR"];
                this.variablesglobales.uservalor2 = usu["CLIENTES_VALOR2"];
                this.variablesglobales.ConfiguraMenu(usu["CLIENTES_VALOR"]);
                if (valor==usu["CLIENTES_VALOR"]){

                  this.variablesglobales.emailoriginal = this.variablesglobales.username;
                  
                  
                  
    
             
                    if (this.variablesglobales.APPSELECT == "PICAJES"){
                      this.myForm.value.email = "";
          
                      this.navCtrl.push(ListPage);    
                    }else{
                       
                      this.events.publish('logged-in');
                      this.navCtrl.push(ListPage);    
                  }
                }
              }
              });
            });
          });

        });

         }
      });
   

  this.loadData();
  
  }

  openInicio() {
    this.acceso();

  }

  openCatalogo(){

  }

  openAltausuario(){

  }

  loadData(){

  
  }

    getGET()
    {
        // capturamos la url
        var loc = document.location.href;

        // si existe el interrogante
        if(loc.indexOf('?')>0)
        {
            // cogemos la parte de la url que hay despues del interrogante
            var getString = loc.split('?')[1];
            // obtenemos un array con cada clave=valor
            var GET = getString.split('&');
            var get = {};
 
            // recorremos todo el array de valores
            for(var i = 0, l = GET.length; i < l; i++){
                var tmp = GET[i].split('=');
                get[tmp[0]] = encodeURI(decodeURI(tmp[1]));
            }
            return get;
        }
    }
 
    accesono(){

    }

  acceso() { 

    if (this.myForm.value.contrasena=='') {

      //console.log("ENTRA EN USUARIO NORMAL DE SOLO LECTURA");

      this.funciones.getAccesoUser(this.myForm.value.email).then(
     data => {
          this.datosacceso = data;
          this.usuarioacceso = JSON.stringify(data);

          this.usuarioaccesoarray = this.usuarioacceso.split('"');

          for (let usu of this.datosacceso) {
            this.variablesglobales.uservalor = usu["CLIENTES_VALOR"];
            this.variablesglobales.uservalor2 = usu["CLIENTES_VALOR2"];
            this.variablesglobales.ConfiguraMenu(usu["CLIENTES_VALOR"]);
            this.variablesglobales.username = usu["CLIENTES_RAZSOCIAL"];
            this.variablesglobales.COLORGLOBAL  =  usu["CLIENTES_COLOR"];
            this.variablesglobales.COLORGLOBAL2  =  usu["CLIENTES_COLOR2"];
            this.variablesglobales.LOGOGLOBAL  =  usu["CLIENTES_LOGO"];
            this.variablesglobales.ESTADOGLOBAL  =  usu["CLIENTES_ESTADO"];
            this.variablesglobales.licencianumero= usu["CLIENTES_LICENCIA_NUMERO"];
            this.variablesglobales.licencianombre= usu["CLIENTES_LICENCIA_NOMBRE"];
            this.variablesglobales.licenciafecha= usu["CLIENTES_LICENCIA_FECHA"];
            this.variablesglobales.licenciadiasrestantes = usu["CLIENTES_LICENCIA_DIAS_RESTANTES"];
            this.variablesglobales.licenciaestado = usu["CLIENTES_LICENCIA_ESTADO"];


            
            
            if (usu["CLIENTES_RAZSOCIAL"] != ""){
         
              this.variablesglobales.logged = true;
              this.variablesglobales.setusername(this.variablesglobales.username);
              this.variablesglobales.CLIENTES_RAZSOCIAL= this.variablesglobales.username;

              this.storage.set('usuario', '');
              this.storage.set('pass', '');
              this.storage.set('valor', '');
              this.storage.set('valor2', '');

              // set a key/value
              this.storage.set('usuario', this.variablesglobales.username);
              this.storage.set('pass', this.myForm.value.contrasena);  
              this.storage.set('valor', this.variablesglobales.uservalor);
              this.storage.set('valor2', this.variablesglobales.uservalor2);


              this.variablesglobales.emailactivo = this.myForm.value.email;

              this.variablesglobales.emailoriginal = this.myForm.value.email;
              this.variablesglobales.CONTROLACCESO = 11;

              console.log("1º" + this.myForm.value.email);

              
              /*  ******************************************
              *****  pagina de inicio *******************************************
              */                
              this.navCtrl.push(ListPage); 

         
            } else {

              if (usu["CLIENTES_EXISTE"] == "NO"){

                alert("El cliente no existe en nuestra base de datos. Verifique que es correcto e intendelo de nuevo.");

              } else {

               alert("La contraseña no es correcta.");

              } 
              setTimeout(function() {
                  document.getElementById("demo").innerHTML="";
              }.bind(this), 2500);

            }

          }//fin del for
          
        })
      




    }else{

    this.funciones.getAcceso2(this.myForm.value.email, this.myForm.value.contrasena).then(
     data => {
          this.datosacceso = data;
          this.usuarioacceso = JSON.stringify(data);

          this.usuarioaccesoarray = this.usuarioacceso.split('"');

          for (let usu of this.datosacceso) {
            this.variablesglobales.uservalor = usu["CLIENTES_VALOR"];
            this.variablesglobales.uservalor2 = usu["CLIENTES_VALOR2"];
            this.variablesglobales.ConfiguraMenu(usu["CLIENTES_VALOR"]);
            this.variablesglobales.COLORGLOBAL  =  usu["CLIENTES_COLOR"];
            this.variablesglobales.COLORGLOBAL2  =  usu["CLIENTES_COLOR2"];
            this.variablesglobales.LOGOGLOBAL  =  usu["CLIENTES_LOGO"];
            this.variablesglobales.ESTADOGLOBAL  =  usu["CLIENTES_ESTADO"];
            this.variablesglobales.licencianumero= usu["CLIENTES_LICENCIA_NUMERO"];
            this.variablesglobales.licencianombre= usu["CLIENTES_LICENCIA_NOMBRE"];
            this.variablesglobales.licenciafecha= usu["CLIENTES_LICENCIA_FECHA"];
            this.variablesglobales.licenciadiasrestantes = usu["CLIENTES_LICENCIA_DIAS_RESTANTES"];
            this.variablesglobales.licenciaestado = usu["CLIENTES_LICENCIA_ESTADO"];

            this.variablesglobales.username = usu["CLIENTES_RAZSOCIAL"];
            this.variablesglobales.emailactivo = usu["CLIENTES_EMAIL"];
            this.variablesglobales.CODIGOTRABAJADOR = usu["CLIENTES_CODIGOCLIENTE"];
            
            //console.log("se asigna valor a uservalor:" + this.variablesglobales.uservalor);
            
            
            if (usu["CLIENTES_RAZSOCIAL"] != ""){
         
              this.variablesglobales.logged = true;
              this.variablesglobales.setusername(this.variablesglobales.username);
              this.variablesglobales.CLIENTES_RAZSOCIAL= this.variablesglobales.username;

              this.storage.set('usuario', '');
              this.storage.set('pass', '');
              this.storage.set('valor', '');
              this.storage.set('valor2', '');


              // set a key/value
              this.storage.set('usuario', this.variablesglobales.username);
              this.storage.set('pass', this.myForm.value.contrasena);  
              this.storage.set('valor', this.variablesglobales.uservalor);
              this.storage.set('valor2', this.variablesglobales.uservalor2);
              this.variablesglobales.emailactivo = this.myForm.value.email;
              this.variablesglobales.emailoriginal = this.myForm.value.email;



              if ( usu["CLIENTES_VALOR"]=="SSSSSSSS"){
                  this.variablesglobales.CONTROLACCESO = 91;
                  //console.log("PONE EN 91")
                }else{
                  this.variablesglobales.CONTROLACCESO = 91;
                  //console.log("PONE EN 50")
                }
                //console.log("Valor de valor: " + this.variablesglobales.CONTROLACCESO );


              /*  ******************************************
              *****  pagina de inicio *******************************************
                this.navCtrl.push(ListPage); 
              */                

                console.log("5º" + this.myForm.value.email);  


              this.navCtrl.push(ListPage); 

         
            } else {

              //console.log("RAZSOCIAL:" + usu["CLIENTES_RAZSOCIAL"]);
              //console.log("EXISTE:" + usu["CLIENTES_EXISTE"]);
              //console.log("ACTIVADO:" + usu["CLIENTES_ACTIVADO"]);

              if (usu["CLIENTES_EXISTE"] == "NO"){

                alert("El cliente no existe en nuestra base de datos. Verifique que es correcto e intendelo de nuevo.");

              } else {

               alert("La contraseña no es correcta.");

              } 
              setTimeout(function() {
                  document.getElementById("demo").innerHTML="";
              }.bind(this), 2500);

            }

          }//fin del for
          
        })
     }
   
     }

  recordarAcceso() {
    const usuario = ((this.myForm && this.myForm.value && this.myForm.value.email) || '').trim();
    if (usuario) {
      this.consultarCorreoRecordatorio(usuario);
      return;
    }

    const alerta = this.alertCtrl.create({
      title: 'Recordar contraseña',
      message: 'Introduce tu usuario para consultar el correo asociado.',
      inputs: [{ name: 'usuario', placeholder: 'Usuario', type: 'text' }],
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Continuar',
          handler: datos => {
            const usuarioIntroducido = datos && datos.usuario ? String(datos.usuario).trim() : '';
            if (usuarioIntroducido) { this.consultarCorreoRecordatorio(usuarioIntroducido); }
            return true;
          }
        }
      ]
    });
    alerta.present();
  }

  consultarCorreoRecordatorio(usuario: string) {
    this.funciones.obtieneCorreoRecordatorio(usuario).then((data: any) => {
      const respuesta: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      if (respuesta.RESULTADO === 'OK' && respuesta.EMAIL_MASCARADO) {
        const confirmacion = this.alertCtrl.create({
          title: 'Recordar contraseña',
          message: 'Se enviar&aacute; un correo a:<br><b>' + respuesta.EMAIL_MASCARADO + '</b><br><br>Si no tienes acceso a ese correo, solicita ayuda por WhatsApp.',
          buttons: [
            { text: 'Ayuda por WhatsApp', handler: () => this.abrirWhatsAppRecordatorio(usuario) },
            { text: 'Enviar correo', handler: () => this.enviarCorreoRecordatorio(usuario) }
          ]
        });
        confirmacion.present();
      } else {
        const sinCorreo = this.alertCtrl.create({
          title: 'Correo no disponible',
          message: 'No hay un correo válido asociado a ese usuario. Puedes solicitar ayuda por WhatsApp.',
          buttons: [
            { text: 'Cerrar', role: 'cancel' },
            { text: 'Solicitar por WhatsApp', handler: () => this.abrirWhatsAppRecordatorio(usuario) }
          ]
        });
        sinCorreo.present();
      }
    });
  }

  enviarCorreoRecordatorio(usuario: string) {
    this.funciones.enviarRecordatorioAcceso(usuario).then((data: any) => {
      const respuesta: any = Array.isArray(data) ? (data[0] || {}) : (data || {});
      this.alertCtrl.create({
        title: respuesta.RESULTADO === 'OK' ? 'Correo enviado' : 'No se pudo enviar',
        message: respuesta.RESULTADO === 'OK' ? 'Revisa la bandeja de entrada y la carpeta de correo no deseado.' : 'Puedes solicitar ayuda por WhatsApp.',
        buttons: respuesta.RESULTADO === 'OK' ? ['Aceptar'] : [
          { text: 'Cerrar', role: 'cancel' },
          { text: 'WhatsApp', handler: () => this.abrirWhatsAppRecordatorio(usuario) }
        ]
      }).present();
    });
  }

  abrirWhatsAppRecordatorio(usuario: string) {
    const texto = 'Necesito recuperar la contraseña de Control Laboral. Usuario: ' + usuario;
    window.open('https://wa.me/34630438995?text=' + encodeURIComponent(texto), '_blank');
  }




openempresa(){
       
            let myModal = this.modalCtrl.create(EmpresasPage, {
              'caption': 'Crear una nueva empresa.'
            }
            );

            myModal.onDidDismiss((data: any) => { 
                this.navCtrl.setRoot(this.navCtrl.getActive().component);   
            }); 
            myModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts